export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/aYJhGAf3bGnvwtZ6CgMoy5/EL_NINO_PAGE_1.png',
    alt: 'Sample page El Niño Is an Ocean and Atmosphere Working Together, explaining what ENSO means, the ocean, the atmosphere and their coupling',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/97jEBi8mqmYCAti88EoJuU/EL_NINO_PAGE_2.png',
    alt: 'Sample page The Thermocline Controls the Cold Water Supply, comparing normal and El Niño thermocline and upwelling',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2xbzTwaTpWfrNhNpKx7tMC/EL_NINO_PAGE_3.png',
    alt: 'Sample page One Ocean. Effects on Every Continent, explaining teleconnections: how, where and when',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/gCWDKn9eswEkJF6y5RQjq7/EL_NINO_PAGE_4.png',
    alt: 'Sample page A Global Forecast Is Not a Local Forecast, a funnel from global ENSO outlook to site decision',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/69EaHER3eV26iarhUrkkRi/EL_NINO_PAGE_5.png',
    alt: 'Sample page ENSO Fundamentals Field Card, with six sections to check status, signal, strength, forecast and local decisions',
  },
];
